import {useLazyQuery, gql} from '@apollo/client'

const userListDetails = gql`
  query userListDetails($groupId: Int, $archive: Boolean, $page: Int, $pageSize: Int) {
    userList(groupId: $groupId, archive: $archive, page: $page, pageSize: $pageSize) {
      GROUP_ID
      TOTAL_COUNT
      USER_LIST {
        FIRST_NAME
        LAST_NAME
        EMAIL_ID
        IS_ACTIVE
        START_DATE
        END_DATE
        ARCHIVED
        IS_TEMPORARY
        ID
        JURISDICTION
        FILTERS
        ADDED_BY_FIRST_NAME
        ADDED_BY_LAST_NAME
        REMOVED_BY_FIRST_NAME
        REMOVED_BY_LAST_NAME
        LAST_UPDATED_DATE_TIME
      }
    }
  }
`

export function useGetUserListDetails(projectId, archive = false) {
  const [getUserListData, {data: userData, loading: loadingUserList, error, refetch}] = useLazyQuery(userListDetails, {
    context: {clientName: 'adminPanel'},
    variables: {
      groupId: Number(projectId),
      archive
    },
    notifyOnNetworkStatusChange: true
  })

  return [getUserListData, {userData, loadingUserList, error, refetch}]
}
